module.exports = __webpack_public_path__ + "img/retainer-cropped-opaque.e741daf1.png";